import { WorkspaceRoleV2 } from 'modules/CreateWorkspaceModal/types';
import { PermissionConfigEntry, PermissionId, workspacesConfig } from 'utils/powerLevelsConfig';

import getEnabledPermissionsForRole from './getEnabledPermissionsForRole';

/**
 * Total number of V2 permissions enabled by `role`, summed across all three
 * scopes (workspace + chat + meeting). Each entry contributes 1 when the role's
 * PL in that entry's scope is `>=` the entry's required PL. Replaces V1
 * `getPermissionsByPowerLevel(powerLevel).length` — see spec/tech.md §9
 * Decision 14 and `RoleListItem`'s "(N permissions)" row annotation.
 */
const getEnabledPermissionCount = (
  role: WorkspaceRoleV2,
  config: Record<PermissionId, PermissionConfigEntry> = workspacesConfig
): number => getEnabledPermissionsForRole(role, config).length;

export default getEnabledPermissionCount;
